import { render } from "./AddClassDialog.vue?vue&type=template&id=7abf0136&scoped=true"
import script from "./AddClassDialog.vue?vue&type=script&lang=js"
export * from "./AddClassDialog.vue?vue&type=script&lang=js"

import "./AddClassDialog.css?vue&type=style&index=0&id=7abf0136&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7abf0136"]])

export default __exports__